import * as React from "react";
import storage from "../../utils/storage";

const Account = storage.getMyAccount();

const AccountContext = React.createContext({ account: Account, setAccount: () => {} });

export {Account, AccountContext};